import {
    MoreWaysToLearnCardData,
    MoreWaysToLearnFragment,
} from '../../../../models/experiencefragments/dyf-more-ways-to-learn';

export class MoreWaysToLearnService {
    public getMoreWaysToLearn(
        experienceContent: MoreWaysToLearnFragment
    ): MoreWaysToLearnFragment | null {
        let mwtlCard: MoreWaysToLearnCardData[];
        if (experienceContent) {
            mwtlCard = experienceContent.cards;
            if (mwtlCard.length > 0) {
                return {
                    title: experienceContent.title,
                    cards: mwtlCard,
                } as MoreWaysToLearnFragment;
            } else return null;
        } else return null;
    }
}
